import { RootState } from 'reduxStore/types';

export const getFtsNotifications = (state: RootState) => state.ftsNotifications.items;
